import styled from 'styled-components';

const SectionWrapper = styled.section`
  background: linear-gradient(to bottom, #ffffff 0%, #f3f6f8 50%, #f3f6f8 100%);
  padding: 50px 0 200px 0;
`;

export default SectionWrapper;
